module.exports = "https://img.zhijierongxing.com/saas/img/sign_income.215d24ec.png";